// src/components/Hermes/HermesChat.tsx

import { useHermes } from '../../hooks/useHermes';
import type { HermesCommand } from '../../types/hermes.types';
import MessageList from './MessageList';
import InputArea from './InputArea';
import QuickActions from './QuickActions';

// 快捷命令定义（全部通过 command 传递，不写 prompt）
const quickCommands: HermesCommand[] = [
  {
    id: 'trading',
    label: '📈 交易',
    command: '查看今日交易',
    category: 'Trading',
  },
  {
    id: 'knowledge',
    label: '📚 知识库',
    command: '打开知识库',
    category: 'Knowledge',
  },
  {
    id: 'news',
    label: '📰 新闻',
    command: '今天有什么新闻？',
    category: 'Business',
  },
  {
    id: 'summary',
    label: '📊 总结',
    command: '总结今天的重点',
    category: 'Workspace',
  },
];

export default function HermesChat() {
  const { messages, loading, sendMessage, sendCommand } = useHermes();

  return (
    <div className="flex flex-col h-full border-l border-white/5 bg-white/5">
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-3 border-b border-white/5">
        <div className="flex items-center gap-2">
          <span className="text-lg">🧠</span>
          <div>
            <h3 className="text-sm font-medium text-white">Hermes</h3>
            <p className="text-[10px] text-gray-500">AI Executive Assistant</p>
          </div>
        </div>
        <div className="flex items-center gap-1">
          <span className="w-2 h-2 rounded-full bg-emerald-400"></span>
          <span className="text-[10px] text-gray-500">Online</span>
        </div>
      </div>

      {/* Message List */}
      <MessageList messages={messages} loading={loading} />

      {/* Quick Actions */}
      <QuickActions actions={quickCommands} onAction={(a) => sendCommand(a as HermesCommand)} />

      {/* Input Area */}
      <InputArea onSend={sendMessage} loading={loading} />
    </div>
  );
}